module.exports = __webpack_public_path__ + "8f41eee8ce3ab240e3966dfa0fbfe677.png";